module.exports = __webpack_public_path__ + "media/images/lp_flow-cv_half_price_soudan-038d51ce494e7df9979b1df340f7ddfc.webp";